import { Button } from "@mantine/core";
import { FeatureGate } from "@src/components/plan/feature-gate/feature-gate";
import { openPlanModal } from "@src/components/plan/plan-modal/plan-modal";
import { FeatureEntity, SupportedFeature } from "@src/gql/graphql";

interface QuotaNoticeSectionProps {
	whiteboardId: string;
}

export function QuotaNoticeSection({ whiteboardId }: QuotaNoticeSectionProps) {
	return (
		<FeatureGate
			feature={SupportedFeature.AddBoardEditors}
			entity={{
				id: whiteboardId,
				type: FeatureEntity.Whiteboard,
			}}
			render={({ stats }) => {
				if (!stats || typeof stats?.quota !== "number") {
					return null;
				}

				return (
					<div className="justify-between mt-2 text-sm text-text-secondary md:flex">
						<p>
							You can invite up to{" "}
							<strong>
								{stats.quota} collaborator{stats.quota === 1 ? "" : "s"}
							</strong>
						</p>

						<Button
							className="p-0 h-auto leading-none text-brand-primary font-bold hover:underline"
							variant="transparent"
							onClick={(e) => {
								e.preventDefault();
								openPlanModal({ source: "collaborator_quota" });
							}}
						>
							Upgrade
						</Button>
					</div>
				);
			}}
		/>
	);
}
